import ChangeTenantModalBridge from './ChangeTenantModalBridge';
import angular from 'angular';

angular
  .module('flowingly.runner')
  .component('changeTenantModal', ChangeTenantModalBridge);
